import type { ReactNode } from 'react';
import { WEB_ICO } from './icons';

interface WebFocusProps {
  label: ReactNode;
  sub?: ReactNode;
  onExit?: () => void;
  width?: number;
  /** Điện thoại: thẻ nội dung tràn hết màn hình (không lề, không viền), header thấp hơn. */
  compact?: boolean;
  children?: ReactNode;
}

/** Chế độ học tập — toàn màn hình, không có nav để tránh phân tán. */
export function WebFocus({ label, sub, onExit, width = 700, compact = false, children }: WebFocusProps) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 40,
        background: 'var(--surface-tint)',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'var(--font-vi)',
      }}
    >
      <div
        style={{
          height: compact ? 52 : 60,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: compact ? '0 12px 0 16px' : '0 24px',
          borderBottom: '1px solid var(--border-default)',
          background: 'var(--surface-page)',
        }}
      >
        <img src="/assets/torii-mark.svg" alt="" style={{ width: 24, height: 24 }} />
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {label}
          </div>
          {sub && <div style={{ fontSize: 11.5, color: 'var(--text-secondary)' }}>{sub}</div>}
        </div>
        <div style={{ flex: 1 }} />
        {!compact && <span style={{ fontSize: 12, color: 'var(--text-secondary)', fontWeight: 600 }}>Esc để thoát</span>}
        <button
          onClick={onExit}
          aria-label="Thoát"
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            border: '1px solid var(--border-default)',
            background: 'var(--surface-page)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {WEB_ICO.close()}
        </button>
      </div>
      <div style={{ flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: compact ? 0 : 24 }}>
        <div
          style={{
            width: '100%',
            maxWidth: compact ? undefined : width,
            height: '100%',
            maxHeight: compact ? undefined : 820,
            background: 'var(--surface-page)',
            border: compact ? 'none' : '1px solid var(--border-default)',
            borderRadius: compact ? 0 : 'var(--radius-card)',
            boxShadow: compact ? 'none' : 'var(--shadow-card)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
